import React, { FC } from "react";
import { Box, Text } from "common";
import { IState } from "store/store.interface";
import { useSelector } from "react-redux";
import { IPaymentMethods } from "store/reducers/paymentMethods.reducers";
interface IProps {
  getValue: (keys: string[]) => string | Date;
  name: string;
}

const PaymentOptionSelectionInfo: FC<IProps> = ({ getValue, name }) => {
  const { paymentMethods = [] } = useSelector((state: IState) => ({
    ...state.promotion,
    ...state.paymentMethods,
  }));

  const values = (getValue(["restrictions", name]) as any)?.value || [];

  const selectedPaymentMethods = paymentMethods.filter(
    (method: IPaymentMethods) => values.includes(method.value)
  );

  if (values.length === 0) {
    return null;
  }

  return (
    <Box>
      <Text fontSize="18px" fontWeight="500" mb={1}>
        Selected Payment Methods
      </Text>
      {selectedPaymentMethods.length > 0 && (
        <Box mb={2}>
          <Text fontSize="14px">
            {selectedPaymentMethods
              .map((paymentMethod: IPaymentMethods) => paymentMethod.label)
              .join(", ")}
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default PaymentOptionSelectionInfo;
